module.exports = __webpack_public_path__ + "static/longsword-66a6beeb37fa5e2408e5635d8e387375.jpg";